export default __webpack_public_path__ + "902dbe25fa71a111900abfa010e59597.mp3";